import React, { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { useAuth } from './context/AuthContext';
import AdminLogin from './pages/auth/AdminLogin';
import SignIn from './pages/auth/SignIn';
import RegistrationDisabled from './pages/auth/RegistrationDisabled';
import AdminDashboard from './pages/admin/AdminDashboard';
import PractitionerDashboard from './pages/practitioner/PractitionerDashboard';
import CheckoutPractitioner from './pages/practitioner/CheckoutPractitioner';
import PatientDashboard from './pages/patient/PatientDashboard';
import LabCatalog from './pages/LabCatalog';
import Loading from './components/common/Loading';

// Create custom theme with Inter font
const theme = createTheme({
  typography: {
    fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  },
});

function App() {
  const { user, loading, checkAuth } = useAuth();

  useEffect(() => {
    checkAuth();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) {
    return <Loading />;
  }

  return (
    <ThemeProvider theme={theme}>
    <Routes>
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route 
        path="/admin-login" 
        element={user ? <Navigate to={`/${user.role}/dashboard`} replace /> : <AdminLogin />} 
      />
      <Route 
        path="/login" 
        element={user ? <Navigate to={`/${user.role}/dashboard`} replace /> : <SignIn />} 
      />
      <Route 
        path="/signup" 
        element={user ? <Navigate to={`/${user.role}/dashboard`} replace /> : <RegistrationDisabled />} 
      />
      <Route
        path="/admin/dashboard"
        element={
          user && user.role === 'admin' ? (
            <AdminDashboard />
          ) : (
            <Navigate to="/admin-login" replace />
          )
        }
      />
      <Route
        path="/practitioner"
        element={
          user && user.role === 'practitioner' ? (
            <PractitionerDashboard />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/practitioner/dashboard"
        element={
          user && user.role === 'practitioner' ? (
            <PractitionerDashboard />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/practitioner/checkout"
        element={
          user && user.role === 'practitioner' ? (
            <CheckoutPractitioner />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/patient/dashboard"
        element={
          user && user.role === 'patient' ? (
            <PatientDashboard />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="/lab-catalog"
        element={<LabCatalog />}
      />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
    </ThemeProvider>
  );
}

export default App;

